/*
 * Actions types
 */
export enum ConsentimentosType {
  CONTRATO_RESQUEST = '@consentimentos/CONTRATO_RESQUEST',
  CONTRATO_SUCCESS = '@consentimentos/CONTRATO_SUCCESS',
  CONTRATO_FAILURE = '@consentimentos/CONTRATO_FAILURE',
  CONSENTIMENTOS_RESQUEST = '@consentimentos/CONSENTIMENTOS_RESQUEST',
  CONSENTIMENTOS_SUCCESS = '@consentimentos/CONSENTIMENTOS_SUCCESS',
  CONSENTIMENTOS_FAILURE = '@consentimentos/CONSENTIMENTOS_FAILURE',
  GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_RESQUEST = '@consentimentos/GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_RESQUEST',
  GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_SUCCESS = '@consentimentos/GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_SUCCESS',
  GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_FAILURE = '@consentimentos/GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_FAILURE',
  GET_ORDER_HANDLE_CHANGE_PAGE_RESQUEST = '@consentimentos/GET_ORDER_HANDLE_CHANGE_PAGE_RESQUEST',
  GET_ORDER_HANDLE_CHANGE_PAGE_SUCCESS = '@consentimentos/GET_ORDER_HANDLE_CHANGE_PAGE_SUCCESS',
  GET_ORDER_HANDLE_CHANGE_PAGE_FAILURE = '@consentimentos/GET_ORDER_HANDLE_CHANGE_PAGE_FAILURE',
  CHANGE_STATE_CONSENTIMENTOS_RESQUEST = '@consentimentos/CHANGE_STATE_CONSENTIMENTOS_RESQUEST',
  CHANGE_STATE_CONSENTIMENTOS_SUCCESS = '@consentimentos/CHANGE_STATE_CONSENTIMENTOS_SUCCESS',
  POST_CONSENTIMENTOS_RESQUEST = '@consentimentos/POST_CONSENTIMENTOS_RESQUEST',
  POST_CONSENTIMENTOS_SUCCESS = '@consentimentos/POST_CONSENTIMENTOS_SUCCESS',
  POST_CONSENTIMENTOS_FAILURE = '@consentimentos/POST_CONSENTIMENTOS_FAILURE',
  RESET_TEMPDATA = '@consentimentos/RESET_TEMPDATA',
}

/*
 * State Type
 */
export interface ConsentimentosState {
  readonly data: any;
  readonly tempData: any;
  readonly contato: any;
  readonly loading: boolean;
  readonly error: boolean;
}
